module.exports = __webpack_public_path__ + "img/cards-box-bg-mob2.5bc4f032.png";